import { defineComponent as _defineComponent } from 'vue'
import { NeoButton } from '@kodadot1/brick'
import VueI18n from 'vue-i18n/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'RedirectModal',
  props: {
    url: null,
    i18n: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  url: string
  i18n: VueI18n
}




const handleRedirect = () => {
  emit('close')
  window.open(props.url, '_blank')
}

return { __sfc: true,emit, props, handleRedirect, NeoButton }
}

})